import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  constructor(private http: HttpClient) {}

  load() {
    // for MVP we decided to go with Domain check
    // After validate the idea we can align with BE team about more robust solution.

    const config = {
      logoURL: '/assets/images/inyova-pro-logo.svg',
      I4KlogoURL: '/assets/images/i4k-pro-logo.svg',
      theme: 'inyova-pro'
    };

    if (document.location.hostname.includes('pro')) {
      Object.assign(environment, config);
      document.documentElement.dataset.theme = environment.theme;
    }
  }
}
